import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8cf6d53e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "time-range-separator" }, "-", -1))

import { ref, watch, computed, onMounted } from 'vue';
import { convertToCustomFormat } from "@/views/screen/component/fomat";
import { useI18n } from "vue-i18n";

const format = 'HH:mm';

export default /*#__PURE__*/_defineComponent({
  __name: 'hourPicker',
  props: {
  timeRange: {
    type: Array,
    default: [],
  },
  isDisable: {
    type: Boolean,
    default: false
  }
},
  emits: ["emitTimeRange", "clearAllTime"],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();

const pickerOptions = {
  selectableRange: '00:00 - 23:59',
  format,
};

const startHour = ref('');
const endHour = ref('');






watch(() => props.timeRange, (newV) => {
  console.log('nnnn', newV);
  // console.log('start',new Date(),getTimeZone((new Date()).toString()));
  startHour.value = newV ? convertToCustomFormat(newV[0], getTimeZone((new Date()).toString())) : ''
  endHour.value = newV ? convertToCustomFormat(newV[1], getTimeZone((new Date()).toString())) : ''
})

// 获取当前时区的后缀
const getTimeZone = (time: any) => {
  console.log('time', time, typeof time);

  const gmtIndex = time.indexOf('GMT');

  if (gmtIndex !== -1) {
    // 获取 "GMT" 之前的部分
    const firstHalf = time.substring(0, gmtIndex).trim();

    // 获取 "GMT" 之后的部分
    const secondHalf = time.substring(gmtIndex).trim();

    // console.log('第一半:', firstHalf);
    // console.log('第二半:', secondHalf);
    return secondHalf
  }
}

const changeStart = (e: any) => {
  // console.log('start',new Date(e).getTime());
  if (new Date(e).getTime() !== 0) {
    if (endHour.value == "") {
      emit("emitTimeRange", [timeFormat(startHour.value), timeFormat("")]);
    } else {
      emit("emitTimeRange", [timeFormat(startHour.value), timeFormat(endHour.value)]);
    }
  } else {
    emit("clearAllTime")
  }
  // console.log('changeStart',[timeFormat(startHour.value),timeFormat(endHour.value)]);
}

const changeEnd = (e: any) => {
  console.log('end', new Date(e).getTime());
  if (new Date(e).getTime() !== 0) {
    emit("emitTimeRange", [timeFormat(startHour.value), timeFormat(endHour.value)]);
  } else {
    emit("clearAllTime")
  }
  console.log('changeEnd', [timeFormat(startHour.value), timeFormat(endHour.value)]);
}

const timeFormat = (time: any) => {
  if (time == '') return '00:00'
  const date = new Date(time);
  console.log('date:', date);

  const hours = ("0" + date.getHours()).slice(-2);
  const minutes = ("0" + date.getMinutes()).slice(-2);

  const timeStr = hours + ":" + minutes;
  return timeStr
}

const endPickerOptions = computed(() => {
  const minEndTime = new Date(startHour.value);
  minEndTime.setMinutes(minEndTime.getMinutes() + 1); // 根据需要调整间隔

  const minEndTimeHours = ('0' + minEndTime.getHours()).slice(-2);
  const minEndTimeMinutes = ('0' + minEndTime.getMinutes()).slice(-2);
  const minEndTimeStr = minEndTimeHours + ':' + minEndTimeMinutes;

  return {
    ...pickerOptions,
    selectableRange: `${minEndTimeStr} - 23:59`,
  };
});


return (_ctx: any,_cache: any) => {
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_di = _resolveComponent("di")!

  return (_openBlock(), _createBlock(_component_di, { class: "time-range-picker" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_time_picker, {
        modelValue: startHour.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startHour).value = $event)),
        "picker-options": pickerOptions,
        format: format,
        placeholder: _unref(t)('famikeep200.Start time'),
        disabled: __props.isDisable,
        "popper-class": "hourPicker",
        onChange: changeStart,
        draggable: "false"
      }, null, 8, ["modelValue", "placeholder", "disabled"]),
      _hoisted_1,
      _createVNode(_component_el_time_picker, {
        modelValue: endHour.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endHour).value = $event)),
        "picker-options": endPickerOptions.value,
        format: format,
        placeholder: _unref(t)('famikeep200.End time'),
        disabled: __props.isDisable,
        "popper-class": "hourPicker",
        onChange: changeEnd
      }, null, 8, ["modelValue", "picker-options", "placeholder", "disabled"])
    ]),
    _: 1
  }))
}
}

})